var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M15 7.93024V13.3566C15 13.7678 14.8244 14.1621 14.5118 14.4529C14.1993 14.7436 13.7754 14.907 13.3333 14.907H1.66667C1.22464 14.907 0.800716 14.7436 0.488155 14.4529C0.175595 14.1621 0 13.7678 0 13.3566V7.93024H15ZM10.8333 0.953491C11.0543 0.953491 11.2663 1.03516 11.4226 1.18054C11.5789 1.32592 11.6667 1.52309 11.6667 1.72869V2.50388H13.3333C13.7754 2.50388 14.1993 2.66722 14.5118 2.95798C14.8244 3.24873 15 3.64308 15 4.05427V6.37985H0V4.05427C0 3.64308 0.175595 3.24873 0.488155 2.95798C0.800716 2.66722 1.22464 2.50388 1.66667 2.50388H3.33333V1.72869C3.33333 1.52309 3.42113 1.32592 3.57741 1.18054C3.73369 1.03516 3.94565 0.953491 4.16667 0.953491C4.38768 0.953491 4.59964 1.03516 4.75592 1.18054C4.9122 1.32592 5 1.52309 5 1.72869V2.50388H10V1.72869C10 1.52309 10.0878 1.32592 10.2441 1.18054C10.4004 1.03516 10.6123 0.953491 10.8333 0.953491Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.9280e064ff08ee675758818c0c7c81a8.svg";
export { ForwardRef as ReactComponent };